/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

import { useState, useContext, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { PublishContext } from '../publish-context/PublishContext'
import type { PatientsSelectionLevel } from '../types'

const PatientsLevelSelections: React.FC = () => {
  const publishContext = useContext(PublishContext)
  const { t: translate } = useTranslation()
  const [selection, setSelection] = useState<PatientsSelectionLevel>('ALL')

  useEffect(() => {
    publishContext?.setSelectionsData((data) => ({ ...data, patientsSelectionLevel: selection }))
  }, [selection])

  const isSiteSelected = !!publishContext?.selectionsData?.siteFolderIds?.length

  return (
    <div className="pdr-publish-level patient-selection-level">
      <div className="selection-wrapper">
        <label className={`control-label ${!isSiteSelected ? 'disabled-label' : ''}`}>{translate('PATIENTS')}</label>
        <div className="level-selection">
          <input
            id="76912ba7-c461-4d0b-b61f-e82c2c03451e"
            className="level-radio"
            type="radio"
            name="patients-level"
            value="ALL"
            checked={selection === 'ALL'}
            onClick={() => {
              setSelection('ALL')
            }}
            onChange={() => {
              // Empty handler to prevent warning
            }}
            disabled={!isSiteSelected}
          />
          <label className={`level-value ${!isSiteSelected ? 'disabled-label' : ''}`}>
            {translate('ALL_PATIENTS')}
          </label>
        </div>
        <div className="level-selection">
          <input
            id="cac92100-cddf-478b-b7a3-8bb4a9b0ff4b"
            className="level-radio"
            type="radio"
            name="patients-level"
            value="CUSTOM"
            checked={selection === 'CUSTOM'}
            onClick={() => {
              setSelection('CUSTOM')
            }}
            onChange={() => {
              // Empty handler to prevent warning
            }}
            disabled={!isSiteSelected}
          />
          <label className={`level-value ${!isSiteSelected ? 'disabled-label' : ''}`}>
            {translate('SELECT_PATIENTS')}
          </label>
        </div>
      </div>
    </div>
  )
}

export default PatientsLevelSelections
